import { TelefoneAction } from "./TelefoneAction";
import { TelefoneActions } from "./TelefoneActions";
import { TelefoneHeader } from "./TelefoneHeader";
import { TelefoneNumber } from "./TelefoneNumber";
import { TelefoneNumbers } from "./TelefoneNumbers";
import { TelefoneRoot } from "./TelefoneRoot";

export const Discador = {
  Action: TelefoneAction,
  ActionsRoot: TelefoneActions,
  Header: TelefoneHeader,
  Number: TelefoneNumber,
  NumbersRoot: TelefoneNumbers,
  Root: TelefoneRoot,
};
